<template>
  <div class="main-multi-select-tabs-container">
    <ul
      class="nav nav-tabs"
      :class="{
        'nav-tabs-assignments': sector === 'assignments' && expand,
        'nav-tabs-assignments-without-ex': sector === 'assignments' && !expand
      }"
      style="border-bottom: 0 ;"
    >
      <li
        v-for="(tab, tabIndex) in tabs"
        :class="{
          active: selected.toLowerCase() === tab.alias.toLowerCase(),
          fLeft: expandToRight,
          'fLeft-sms': sector === 'sms',
          fRight: !expandToRight && sector !== 'countries',
          'fRight-countries': sector === 'countries',
          'fRight-na': sector === 'no_answer',
          'fRight-tr': sector === 'transfer',
          'fRight-rf': sector === 'referral',
          'fRight-ld': sector === 'leads',
          'fRight-dp': sector === 'deposits',
          'fRight-assign': sector === 'assignments'
        }"
        @click="setTab(tab)"
        :key="tabIndex"
        style="font-weight: 900;"
      >
        <a
          href="javascript:void(0)"
          :style="background.mainBg"
          :class="{ hideItForNow: tab.name === 'Auto Status' }"
          >{{ tab.name }}</a
        >
      </li>
      <li v-if="sector === 'countries'" class="for-matrix">
        <a
          @click="
            [
              $store.commit('clients/setClickedOnMatrixCountries', true),
              $emit('closeIt', false)
            ]
          "
          :style="background.mainBg"
          >MATRIX</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import leads from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/ld/leads";
import assignments from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/assignments/assignments";
import call_again from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/ca/call_again";
import deposits from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/dp/deposits";
import transfer from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/tr/transfer";
import countries from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/countries/countries";
import sms from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/sms/sms";
import referral from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/referral/referral";
import no_answer from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/no_answer/no_answer";
import { mapGetters, mapState } from "vuex";

export default {
  name: "MultiSelectTabs.component",
  mixins: [
    UsersPermissionCheck,
    leads,
    assignments,
    call_again,
    deposits,
    transfer,
    countries,
    sms,
    referral,
    no_answer
  ],
  props: {
    expand: {
      type: Boolean
    },
    background: {
      type: Object
    },
    expandToRight: {
      type: Boolean,
      default: false
    },
    sector: {
      type: String
    },
    hasTabs: {
      type: Boolean
    },
    open: {
      type: Boolean
    }
  },

  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "multiSelectChartData"]),
    ...mapGetters("clients", [
      "getName",
      "getActives",
      "getDp",
      "showCart",
      "showCartMonth",
      "getMultiSelectChartData"
    ]),
    setStyleRoot() {
      ///TODO: GABI: ADD TO ARRAY ALL RELEVANT SECTORS TO LEFT OPEN EXTENSION TYPE
      const sectorsList = [
        "deposits",
        "leads",
        "referral",
        "placement",
        "questions_status",
        "call_again",
        "transfer",
        "no_answer",
        "questions",
        "keyword",
        "device",
        "click_type",
        "location",
        "advertising"
      ];
      if (sectorsList.includes(this.sector)) {
        return "right: -70px";
      } else {
        return "";
      }
    }
  },

  created() {
    if (this.hasTabs && this[this.sector].length > 0) {
      this.tabs = this[this.sector];
      this.$emit("listOfTabs", this.tabs);
      this.selectedTab = this[this.sector][0].alias.toLowerCase();
      this.selected = this.selectedTab.toUpperCase();
    }
  },

  data() {
    return {
      selected: "",
      selectedTab: "",
      tabs: []
    };
  },

  methods: {
    setTab(tab) {
      this.selected = tab.alias;
      this.selectedTab = tab.alias.toLowerCase();
    }
  },

  watch: {
    "multiSelectChartData.fromChart": function() {
      if (
        this.multiSelectChartData.selectedSector === this.sector &&
        this.multiSelectChartData.fromChart
      ) {
        let tab = this.multiSelectChartData.data[this.sector].selectedTab;
        this.selected = tab;
        this.selectedTab = tab.toLowerCase();

        /// multiSelectChartData(){/// integration
        ////   if(this.multiSelectChartData.mainSector === this.sector){ /// integration
        ////    this.selectedTab = this.multiSelectChartData.selectedTab /// integration
      }
    },
    selectedTab() {
      this.$emit("multiSelectTabChanged", this.selectedTab.toLowerCase());
    }
  }
};
</script>

<style scoped>
.nav {
  height: 20px;
  margin-bottom: 5px;
  position: absolute;
  top: -25px;
  right: 172px;
}

.nav-tabs a {
  height: 25px;
  padding: 5px;
  font-size: 8pt;
  background-color: #ae3ede;
  color: white;
}

.nav-tabs a:hover {
  background: #eceff1;
}

.nav-tabs li.active {
  border-top-color: transparent !important;
  border-bottom: 1px solid #1e88e5;
  font-size: 10pt;
  color: #1e88e5;
}

.nav-tabs li {
  margin: 0;
}

.nav-tabs li:hover {
  background: none;
  margin: 0;
}
.nav-tabs > li > a {
  font-size: 11px !important;
  text-transform: uppercase;
}

.fRight {
  float: right;
  background-color: inherit;
}
.fRight-countries a {
  float: right;
  background-color: grey !important;
}
.fLeft {
  float: left;
}
.fLeft-sms a {
  float: left;
  background-color: grey !important;
}
.main-multi-select-tabs-container {
  /*min-width: 600px;*/
  width: 360px;
}
.nav-tabs-assignments {
  right: 15px !important;
}
.nav-tabs-assignments-without-ex {
  right: -2px !important;
}
a.hideItForNow {
  display: none !important;
}
.fLeft-sms {
  position: relative;
  right: -37px;
}
.fRight-assign {
  position: relative;
  right: 70px;
}
.fRight-na,
.fRight-tr,
.fRight-rf,
.fRight-ld,
.fRight-dp,
.fRight-countries {
  position: relative;
  right: -35px;
}
li.for-matrix {
  position: absolute;
  right: 175px;
}
li.for-matrix a {
  background-color: grey;
}
li.for-matrix a:hover {
  background-color: grey;
  cursor: pointer;
}
</style>
